window.registerCopyElements = function(){
    document.querySelectorAll('.copy').forEach(button => {
        button.addEventListener('click', event => {
            var textarea = document.createElement("textarea");
            textarea.textContent = event.target.dataset.copy;
            textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            
            document.body.removeChild(textarea);
        });
    });
}

window.registerCopyElements();